import { DatePicker } from "antd";
import styled from "styled-components";

const DateField = styled(DatePicker)`
  width: 100%;
`;

export { DateField };
